import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { deleteRichTextFromArticle, getTop10ArticleByID } from "../action";
import { ITop10Article } from "../../../types/Top10Article";
import { Button, message, Table } from "antd";
import { PiPlus } from "react-icons/pi";
import { Top10RichtTextColumns, Top10RichtTextDataType } from "../types";
import DashModal from "../../../Components/DashModal";
import AddRichTextArticle from "./AddNewTop10RichText";
import EditRichTextArticle from "./EditRichText";
type Props = {
  page: number;
  pageSize: number;
  addNewRichText?: boolean;
  editRichText?: boolean;
};

const ManageTop10RichText = (props: Props) => {
  const { page, pageSize } = props;
  const { id } = useParams();
  const [top10Article, setTop10Article] = useState<ITop10Article | null>(null);
  const [data, setData] = useState<Top10RichtTextDataType[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const top_10_article = await getTop10ArticleByID(id!);
    setTop10Article(top_10_article);
    let items: Top10RichtTextDataType[] = [];
    if (top_10_article) {
      top_10_article.SortedItems.map((st) => {
        if (st.Type === "TEXT") {
          if (st.RichText) {
            items.push({
              id: st.RichText?.id,
              title: st.RichText?.Title,
            });
          }
        }
      });
    }
    setLoading(false);
    setData(items);
  };

  const handleDelete = async (richtextid: string) => {
    try {
      await deleteRichTextFromArticle(id!, richtextid);
      fetchData();
      message.success("Rich text deleted successfully");
    } catch (err) {
      message.error("Failed to delete rich text");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className=" space-y-5">
      <div className="flex justify-between items-center">
        <Link
          to={`/top10-articles/manage-rich-text/${id}/add?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="primary" icon={<PiPlus />}>
            Add New Rich Text
          </Button>
        </Link>
      </div>

      <Table<Top10RichtTextDataType>
        rowKey="id"
        columns={Top10RichtTextColumns(id!, page, pageSize, handleDelete)}
        dataSource={data}
        loading={loading}
        pagination={false}
      />

      {props.addNewRichText && (
        <DashModal
          title="Add New Rich Text"
          width={1500}
          cancleLink={`/top10-articles/manage-rich-text/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <AddRichTextArticle fetchData={fetchData} />
        </DashModal>
      )}

      {props.editRichText && (
        <DashModal
          title="Edit Rich Text"
          width={1500}
          cancleLink={`/top10-articles/manage-rich-text/${id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <EditRichTextArticle fetchData={fetchData} />
        </DashModal>
      )}
    </div>
  );
};

export default ManageTop10RichText;
